import { Container, Divider, Typography } from '@mui/material'
import React from 'react'

export default function InternalFrontend(props) {


    return (
        <Container sx={{paddingBlock:2}}>
            <Typography variant='h3'>How the Frontend Works</Typography>
            <Divider></Divider>
            <br />
            Frontend <br />
            The Frontend for the Blitz App is built using React. 
            Routing works by React Router, which allows us to create a mostly single page application.
            Calls to the Backend work with the React Query library. Queries are used to fetch data, mutations are used to change data.
            The calls to the backend are defined in the src/API/index.js file.
            <br />
            <br />
            The Frontend is built using the MUI library. This allows us to create a consistent look and feel across the app.
            The theme is defined in the src/Utils/baseTheme.js file. This allows us to change the look and feel of the app easily.
            We should never hardcode colors in any component, as they would clash with the dynamic dark mode and light mode.
            <br />
            <br />
            We have two user roles in the app. 'creator' and 'user'. The creator role can only login in to the CreatorConnect area of the app.
            The user role can login to the main Blitz app.
            <br />
            We save user data to the browser cookies. The cookie keys are defined and are different between user and creator.
            When a creator logs in, we delete user cookies and visceversa.
            <br />
            The API client codes checks for a creator token, then for an user token, and if any exists, its sent in the request header as a bearer token.
            When a http unauthorized error is returned, we delete the cookies and redirect the user to the login page. If you don't want this, you can
            add the ignoreAuthError option to your route definition in backend calls file. This way http unauthorized errors wont invalidate the user.
            <br />
            The Frontend is deployed to Vercel. Vercel is a plugin in the github repo. When we push to the main branch, it deploys the app to production.
            <br />
            Various batch file are included to execute a local version of the app. The batch files are located in the root of the project.<br />
            <br />
            We use node version 20.x, the same as Vercel. <br />
            run_blitz_front_envs.bat is a helper script that loads the correct .env variables. <br />
            run_blitz_front_install.bat runs the npm install command to install all dependencies. <br />
            run_blitz_front.bat runs the npm run start command to start the app. <br />



        </Container>
    )
}
